import React, { FC } from 'react';
import { TextFieldSize, Text, Box } from '@bechtel/gds';
import { CommentsProps } from './types';
import { t } from '@lingui/macro';
import { TextAreaStyled } from '../comment/styled';
import { useField } from 'formik';
import { useLingui } from '@lingui/react';

export const RodRequestComments: FC<CommentsProps> = ({ fieldName }) => {
  const { i18n } = useLingui();
  const [field, meta] = useField(fieldName);
  return (
    <Box data-testid="comment-input" px={{ sm: '500' }} py={{ sm: '500' }} flexDirection={{ sm: 'column' }}>
      <TextAreaStyled maxLength={2000} {...field} placeholder={t`Comments`} size={TextFieldSize.LARGE} rows="4" />
      {meta.touched && meta.error ? (
        <Box pt={{ sm: '200' }}>
          <Text color="bechtel.red">{i18n._(meta.error)}</Text>
        </Box>
      ) : null}
    </Box>
  );
};
